import { RouterRoute } from '@fsd/shared/types';

export const FINANCE_ROUTES: Record<string, RouterRoute> = {
  DEPOSIT: {
    PATH: '/finance/deposit',
    NAME: 'deposit',
  },
  FINANCE_WITHDRAW: {
    PATH: '/finance/withdraw',
    NAME: 'finance-withdraw',
  },
  FINANCE_WITHDRAW_REQUEST_CREATED: {
    PATH: '/finance/withdraw/request-created',
    NAME: 'finance-withdraw-request-created',
  },
  CREATE_PAYMENT_METHOD: {
    PATH: '/finance/create-payment-method',
    NAME: 'finance-create-payment-method',
  },
  TRANSFER: {
    PATH: '/finance/transfer',
    NAME: 'transfer',
  },
  OPERATIONS_HISTORY: {
    PATH: '/finance/operations-history',
    NAME: 'finance-operations-history',
  },
  OPERATIONS_HISTORY_ITEM: {
    PATH: '/finance/operations-history/:id',
    NAME: 'finance-operations-history-item',
  },
};
